var styles = {"root":"list-of-links-section--root","sectionHeading":"list-of-links-section--section-heading"};

export { styles as default };
//# sourceMappingURL=ListOfLinksSection.module.esm.js.map
